import { Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { Box, ButtonStyled, HeadingStyled } from "../../../styled/Elements";
import {
  CancelWithBg,
  LeftArrowBlack,
  RightArrowWhite,
  RightArrowWithoutBar,
} from "../../../styled/AllImages";
import ValidatedInput from "../../../common/inputFields/ValidatedInput";
import CategoriesApi from "../../../../services/api/categoriesApi";
import { toast } from "react-toastify";
import { useState } from "react";

const CreateCategoryModal = ({
  show,
  onHide,
  title,
  action,
  planInfo,
  getCategoriesList,
  activePage,
}) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { value } = e.target;
  };

  const onSubmit = async (data) => {
    const updatedData = {
      ...data,
      action: "create",
    };
    // const formData = new FormData();
    // Object.entries(updatedData).forEach(([key, value]) => {
    //   formData.append(key, value);
    // });

    try {
      setLoading(true);
      const { code } = await CategoriesApi.createCategory(updatedData);
      if (code === 200) {
        reset();
        onHide();
        toast.success(t("category_created_successfully"));
        getCategoriesList(activePage);
        dispatchEvent(new Event("productCategoryUpdated"))
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal size="md" show={show} onHide={onHide} centered>
      <SelectUserModalWrapper>
        <Box className="">
          <Box className="d-flex justify-content-between align-items-center border-bottom mb-4 p-4">
            <HeadingStyled size="24px" weight="bold" color="var(--text)">
              {title}
            </HeadingStyled>
            <CancelWithBg
              className="cursor-pointer"
              style={{ height: "33px", width: "33px" }}
              onClick={onHide}
            />
          </Box>
        </Box>
      </SelectUserModalWrapper>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Box className="paddingExceptTop">
          <ValidatedInput
            start="start"
            column="column"
            weight="600"
            name="name_en"
            type="input"
            fieldType="text"
            placeholder="e.g. Home & Living"
            label="name_en"
            className="combined px-0"
            // staric="staric"
            register={register}
            errors={errors}
            validationRules={{
              required: true,
            }}
          />
          <ValidatedInput
            start="start"
            column="column"
            weight="600"
            name="name_ar"
            type="input"
            fieldType="text"
            placeholder="مثال: المنزل والمعيشة"
            label="name_ar"
            className="combined px-0"
            // staric="staric"
            register={register}
            errors={errors}
            validationRules={{
              required: true,
            }}
          />
        </Box>
        <Box className="modal-footer">
          <ButtonStyled
            border="var(--borderExtraLight)"
            iconBefore={LeftArrowBlack}
            bg="transparent"
            label={t("Cancel")}
            color="var(--text)"
            type="button"
            onClick={() => {
              onHide();
              reset();
            }}
          />
          <ButtonStyled
            bg="var(--themeColor)"
            label={t("create")}
            type="submit"
            icon={RightArrowWhite}
            isLoading={loading}
          />
        </Box>
      </Form>
    </Modal>
  );
};

export default CreateCategoryModal;

const SelectUserModalWrapper = styled.div``;
